export const delay = (t = 500) => new Promise((resolve) => setTimeout(resolve, t));
